import { createAction } from 'redux-actions';

function defaultPayload(payload = {}, meta = {}) {
  return payload;
}

function defaultMeta(payload = {}, meta = {}) {
  return meta;
}

export default function createActionHelper(
  type,
  payloadFunc = defaultPayload,
  metaFunc = defaultMeta
) {
  return createAction(type, payloadFunc, metaFunc);
}
